export default function UnitOfMeasureTitleRenderer(unitOfMeasure) {
    const unitOfMeasureTitleMapping = {
        UNITS: "Unidades",
        KG: "Kilogramos"
    };
    return unitOfMeasureTitleMapping[unitOfMeasure] || ""
}
